<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
      <div class="h-100">
        <div class="text-center">
          <img :src="imageUrl" :alt="block.image_alt" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      block: Object,
    },
    computed: {
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
      imageUrl() {
        return this.block.image_url
      },
    },
  }
</script>